import { BreakpointObserver } from '@angular/cdk/layout';
import { PlatformLocation } from '@angular/common';
import { Component, OnInit, Output, Input, EventEmitter, ViewChild, Renderer2, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { PlanSlideComponent } from '../plan-slide/plan-slide.component';
import { HttpService } from 'src/services/http.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorReportService } from 'src/services/error-report.service';

@Component({
  selector: 'app-finish-company',
  templateUrl: './finish-company.component.html',
  styleUrls: ['./finish-company.component.scss']
})
export class FinishCompanyComponent implements OnInit {

  @Output() submitted = new EventEmitter<boolean>();
  @Input() isFree: boolean = false;
  formPlan: FormGroup;
  mauticFormSrc: any = null;
  @ViewChild('PlanSlide', { static: false }) planSlide: PlanSlideComponent;
  planoselecionado: boolean = false;
  formVoucher: FormGroup;
  success: boolean = false;
  message: string = 'Digite o código do cupom abaixo:';
  special_plan: boolean = false;

  constructor(
    fb: FormBuilder,
    private sanitazer: DomSanitizer,
    private pLocation: PlatformLocation,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpService,
    private snackbar: MatSnackBar,
    private renderer: Renderer2,
    private el: ElementRef,
    private errorReport: ErrorReportService,
  ) {
    this.formPlan = fb.group({
      email: [localStorage.getItem('email')],
      acceptTerm: [false, Validators.required],
      // acceptSendMessage: [false],
      planSignature: [null],
      planCode: [null],
      acceptContract: [false, Validators.required],
    });
    this.formVoucher = fb.group({
      user: [localStorage.getItem('email')],
      code: [null]
    })

    this.route.queryParams.subscribe(
      query => {
        if (query.pi && query.valid && this.planSlide) {
          this.planSlide.selectPlanBy(query.pi);
        }
      }
    )
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.route.queryParams.subscribe(query => {
      let planIndex;
      switch (query['plan']) {
        case 'trimestral_plus':
          planIndex = 5;
          break;
        case 'anual':
          planIndex = 4;
          break;
        case 'semestral':
          planIndex = 3;
          break;
        case 'trimestral':
          planIndex = 2;
          break;
        case 'mensal':
          planIndex = 1;
          break;
      }

      let cupom;
      switch (query['cupom']) {
        case 'OFF03MES':
          cupom = 'OFF03MES';
          break;
        case 'OFF01ANO':
          cupom = 'OFF01ANO';
          break;
      }

      if(cupom != ''){
        this.formVoucher.patchValue({
          code: cupom
        })
      }

      if (planIndex !== 5) {
        this.planSlide.plans = this.planSlide.plans.filter(plan => plan.code !== 'TREEMONTHLY_BUSINESS_PLUS');
      }

      if (planIndex !== -1 && this.planSlide) {
        this.planSlide.selectPlanBy(planIndex);
        setTimeout(() => {
          this.planSlide.navigateToSelectedPlan(planIndex);
        }, 3000);
      }
      
      setTimeout(() => {
        if(planIndex == 5){
          this.special_plan = true;
        }
      }, 4000);

    });
  }


  choosePlan(plan) {

    if (plan) {

      this.formPlan.patchValue({
        planCode: plan.code,
        planSignature: plan.price,
        email: localStorage.getItem('email')
      });
      this.planoselecionado = true;

      plan.selected = true;
    }

  }

  doneAll() {
    if (!this.formPlan.invalid) {

      const data = this.formPlan.getRawValue();
      
      const email = localStorage.getItem('email');
      this.makeAccountTrial(email);
      this.makePlanCompany(JSON.stringify(data));

      const user = {
        email: localStorage.getItem('email'),
        subject: 'Colloca | Bem-vindo(a) à nossa plataforma!',
        fullname: localStorage.getItem('name'),
        new: 'true',
        template: '300d9cb2-4bb3-446c-9ce1-94e1896eafee'
      }
  
      this.http.save('onsignal:sendEmail', user)
        .subscribe(
          (result: any) => {
  
            if (result.type === 'OK') {
              //console.log('email enviado');
            }
          },
          err => this.errorReport.showMessage(err)
        );

      const params = new URLSearchParams();

      for (let key in data) {
        const value = data[key];
        if (value)
          params.append(key, value);
      }

      const hBase = this.pLocation.getBaseHrefFromDOM();

      this.mauticFormSrc = this.sanitazer
        .bypassSecurityTrustResourceUrl(`${hBase}mautic-form/finish?${params.toString()}`);
      // console.log('mauticFormSrc:', this.mauticFormSrc);

      const datas = {
        email: localStorage.getItem('email'),
        password: localStorage.getItem('password')
      }
      // console.log('DATA', datas);
      // this.http.save('auth:login', datas)
      //   .subscribe(
      //     (result: any) => {
      //       console.log('RESULT', result)
      //       if (result.datas) {
      //         localStorage.setItem('token', JSON.stringify(result.datas));
      //setTimeout(() => this.router.navigate(['/recruiter/welcome']), 500);
      //         }
      //       }
      //     )

      setTimeout(() => {
        alert('Cadastro concluído com sucesso');
        this.router.navigate(['/']);
      }, 2000);

    }

  }

  private makeAccountTrial(email: string) {
 
    this.http.save('profile:make_trial', { email: email })
      .subscribe(
        (result: any) => {
          // console.log('TRIAL', result); 
        },
        err => console.error(err)
      )

  }

  private makePlanCompany(data:any) {
    
    let parsedData = data;

    if (typeof data === 'string') {
        parsedData = JSON.parse(data); // transforma para objeto

        if (!parsedData['email']) {
          parsedData['email'] = localStorage.getItem('email'); 
        }

        // adiciona o campo 'use_ia' no objeto
        if (this.special_plan) {
          parsedData['use_ia'] = 1;
        }
        // transforma de volta para string JSON
        parsedData = JSON.stringify(parsedData);
    }
    
    this.http.save('company:plan_mark', { data: parsedData })
      .subscribe(
        (result: any) => {
          // console.log('PLAN Empresa', result); 
        },
        err => console.error(err)
      )

  }

  submitCode() {
    //console.log('entrou no cupom');
    const isValid = !this.formVoucher.invalid;

    if (isValid) {

      if(this.formVoucher.controls['code'].value === null){
        return false;
      }

      //console.log('chegou Valido');
      const data = this.formVoucher.getRawValue();
      
      if (!data.user) {
        data.user = localStorage.getItem('email'); 
      }

      this.http.save('company:cupom', data)
        .subscribe(
          (result: any) => {
            //console.log('CUPOM', result);
            if (result.type === 'OK') {
              
              const threeMonthsLater = new Date();
              if(data.code == 'OFF01ANO'){
                threeMonthsLater.setDate(threeMonthsLater.getDate() + 365);
              }else{
                threeMonthsLater.setDate(threeMonthsLater.getDate() + 90);
              }

              this.success = true;

              this.formVoucher.get('code').disable();
              this.formVoucher.get('code').setErrors(null);
              this.formVoucher.get('code').markAsUntouched();
              this.message = `Seu cupom foi inserido com sucesso e vence em ${threeMonthsLater.toLocaleDateString()}.`;
              this.snackbar.open(' Seu cupom foi inserido com sucesso !!!', 'OK', { duration: 3000 });

              setTimeout(() => {
                if (this.success) {
                  const outline = this.el.nativeElement.querySelector('.mat-form-field-appearance-outline.mat-form-field-disabled .mat-form-field-outline');
                  const outline2 = this.el.nativeElement.querySelector('.mat-form-field-label');
                  const outline3 = this.el.nativeElement.querySelector('.mat-form-field-infix input');
                  if (outline) {
                    this.renderer.setStyle(outline, 'color', 'rgb(14, 219, 14)');
                    this.renderer.setStyle(outline, 'background', '#e5fbe4');
                    this.renderer.setStyle(outline2, 'color', 'rgb(14, 219, 14)');
                    this.renderer.setStyle(outline3, 'font-size', '20px');
                    this.renderer.setStyle(outline3, 'color', '#0edb0e');
                    this.renderer.setStyle(outline3, 'font-weight', '800');
                  }
                }
              }, 200);

            } else if (result.type === 'FAIL') {
              this.formVoucher.get('code').setValue(null);
              this.snackbar.open('Seu cupom é inválido ou já foi utilizado, tente com um código válido ou efetue o pagamento', 'OK', { duration: 5000 })
            }

          },
          err => this.errorReport.showMessage(err)
        );

    }

  }

}
